import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import _get from 'lodash/get.js';
import classNames from 'classnames';
import { applyStylingHoc } from '../../lib/styling.js';
import collapsibleStyles from '../Collapsible/Collapsible.scss';
import Trigger from './Trigger.js';
import Closer from './Closer.js';

var Content = /*#__PURE__*/function (_PureComponent) {
  _inherits(Content, _PureComponent);

  var _super = _createSuper(Content);

  function Content(props) {
    var _this;

    _classCallCheck(this, Content);

    _this = _super.call(this, props);

    _this.handleClose = function () {
      var onClose = _this.props.onClose; // if we have onClose handler it's assumed that OffCanvas is controlled externally

      if (onClose) {
        onClose();
      } else {
        _this.toggleMenu();
      }
    };

    _this.handleOverlayClose = function () {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          onOverlayClose = _this$props.onOverlayClose; // if we have onClose / onOverlayClose handler it's assumed that OffCanvas is controlled externally

      if (onOverlayClose) {
        onOverlayClose();
      } else if (onClose) {
        onClose();
      } else {
        _this.toggleMenu();
      }
    };

    _this.handleItemClick = function (e) {
      var classList = _get(e, 'target.classList');

      if (!classList) {
        return null;
      }

      !classList.contains(collapsibleStyles.trigger) && _this.toggleMenu();
    };

    _this.toggleMenu = function () {
      _this.setState(function (state) {
        return {
          isOpen: !state.isOpen
        };
      });
    };

    _this.listenForClose = function (e) {
      if (_this.state.isOpen && (e.key === 'Escape' || e.keyCode === 27)) {
        _this.handleClose();
      }
    };

    _this.handleTriggerClick = function () {
      _this.toggleMenu();
    };

    _this.state = {
      isOpen: props.isOpen === undefined ? Boolean(props.isOpenByDefault) : Boolean(props.isOpen)
    };
    return _this;
  }

  _createClass(Content, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.onkeydown = this.listenForClose;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onStateChange = this.props.onStateChange;

      if (onStateChange && prevState.isOpen !== this.state.isOpen) {
        onStateChange(this.state);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.onkeydown = null;
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this$props2 = this.props,
          styles = _this$props2.styles,
          innerId = _this$props2.innerId,
          header = _this$props2.header,
          title = _this$props2.title,
          titleIcon = _this$props2.titleIcon;
      var result;

      if (header) {
        result = React.createElement("div", {
          className: styles.customHeader,
          id: 'offcanvas-nav-header-' + innerId
        }, header);
      } else if (title || titleIcon) {
        result = React.createElement("div", {
          className: styles.header,
          id: 'offcanvas-nav-header-' + innerId
        }, titleIcon && React.createElement("span", {
          className: classNames(titleIcon, styles.titleIcon)
        }), title && React.createElement("div", {
          className: styles.title
        }, title));
      }

      return result;
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      if (this.props.footer) {
        return React.createElement("div", {
          className: this.props.styles.footer
        }, this.props.footer);
      }
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          closeOnItemClick = _this$props3.closeOnItemClick;

      if (!closeOnItemClick) {
        return children;
      }

      return React.Children.map(children, function (item, index) {
        var extraProps = {
          key: index,
          onClick: _this2.handleItemClick
        }; // @ts-ignore

        return item ? React.cloneElement(item, extraProps) : null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      var _this$props4 = this.props,
          innerId = _this$props4.innerId,
          styles = _this$props4.styles,
          noOverlay = _this$props4.noOverlay,
          right = _this$props4.right,
          closerIcon = _this$props4.closerIcon,
          triggerIcon = _this$props4.triggerIcon,
          triggerRenderer = _this$props4.triggerRenderer,
          customCloser = _this$props4.customCloser,
          theme = _this$props4.theme,
          triggerLabel = _this$props4.triggerLabel,
          triggerProps = _this$props4.triggerProps,
          keepMounted = _this$props4.keepMounted;
      var isOpen = this.state.isOpen;
      var overlay = null;

      if (!noOverlay) {
        overlay = React.createElement("div", {
          className: styles.overlay,
          onClick: this.handleOverlayClose
        });
      }

      var svg = null;

      if (styles.svg) {
        svg = React.createElement("div", {
          className: styles.svgShape
        }, React.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "100%",
          height: "100%",
          viewBox: "0 0 100 800",
          preserveAspectRatio: "none"
        }, React.createElement("path", {
          d: _get(styles, 'svg.pathInitial')
        })));
      }

      return React.createElement("div", {
        className: classNames(styles.root, theme, styles["theme-".concat(theme)], (_classNames = {}, _defineProperty(_classNames, styles['is-open'], isOpen), _defineProperty(_classNames, styles['has-overlay'], !noOverlay), _defineProperty(_classNames, styles['is-right'], right), _defineProperty(_classNames, styles['is-active'], true), _classNames))
      }, overlay, React.createElement("div", {
        id: 'content-wrap-' + innerId,
        className: styles.contentWrap
      }, svg, React.createElement("div", {
        className: styles.contentInner
      }, isOpen || keepMounted ? this.renderHeader() : null, isOpen || keepMounted ? React.createElement("nav", {
        className: styles.nav,
        "aria-labelledby": 'offcanvas-nav-header-' + innerId
      }, this.renderBody()) : null, isOpen || keepMounted ? this.renderFooter() : null), customCloser ? React.createElement("div", {
        className: styles.customCloser,
        onClick: this.handleClose
      }, customCloser) : React.createElement(Closer, {
        styles: styles.closer,
        onClick: this.handleClose,
        icon: closerIcon
      })), triggerRenderer ? triggerRenderer(function () {
        return _this3.toggleMenu();
      }, isOpen) : React.createElement(Trigger, _objectSpread({
        styles: styles.trigger,
        onClick: this.handleTriggerClick,
        triggerIcon: triggerIcon,
        triggerLabel: triggerLabel
      }, triggerProps)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (typeof props.isOpen !== 'undefined' && props.isOpen !== state.isOpen) {
        return {
          isOpen: props.isOpen
        };
      }

      return null;
    }
  }]);

  return Content;
}(PureComponent);

Content.defaultProps = {
  id: '',
  innerId: '',
  styles: {},
  noOverlay: false,
  onStateChange: function onStateChange() {},
  outerContainerId: '',
  pageWrapId: '',
  width: 300,
  theme: 'light',
  closeOnItemClick: false
};
export default applyStylingHoc({})(Content);